





























































import { Component, Prop, Mixins } from 'vue-property-decorator';
import PageLoader from '@components/common/PageLoader.vue';
import BasicSelect from '@/components/common/BasicSelect.vue';
import ApiHelper from '@/api/ApiHelper';
import Toast from '@common/helpers/toast';
import WindowSizeMixin from '@common/mixins/WindowSizeMixin';

@Component({
  components: {
    PageLoader,
    BasicSelect,
  },
})
export default class PopupConfirmDoctor extends Mixins(WindowSizeMixin) {
  @Prop({ default: false }) readonly disabledBtSubmit!: boolean;
  @Prop({ default: false }) readonly disabledBtCancel!: boolean;

  form: { doctor_id: number | null } = { doctor_id: null };
  isLoading: boolean = false;
  listDoctors: any[] = [];

  get modalWidth() {
    return this.windowWidth <= 767 ? '92%' : '65%';
  }

  onBeforeOpen() {
    this.form = { doctor_id: null };
    this.listDoctorName();
  }

  listDoctorName() {
    this.isLoading = true;
    const params = {
      current_page: 'patients',
    };
    ApiHelper.getApi('DoctorApi')
      .getList(params)
      .then((res: any) => {
        this.listDoctors = res.data.map((doctor) => ({id: doctor.id, name: doctor.name}));
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  cancelSetDoctor() {
    this.$emit('cancel');
  }

  handleSubmit() {
    this.$emit('submit', this.form);
  }
}
